import { Toolbar } from '@box/blueprint-web';
import { ListBullet, ListNumber } from '@box/blueprint-web-assets/icons/Fill';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { LIST_STYLES } from '../../../constants';
import messages from '../../../messages';

type ListStylesDropdownProps = {
  editor: Editor;
};

export const ListStylesToggleGroup = ({ editor }: ListStylesDropdownProps) => {
  const intl = useIntl();

  return (
    <Toolbar.ToggleGroup type="single">
      <Toolbar.ToggleItem
        aria-label={intl.formatMessage(
          messages.editorToolbarBulletListAriaLabel,
        )}
        icon={ListBullet}
        value={LIST_STYLES.BULLET_LIST}
        onClick={() => {
          editor.chain().focus().toggleBulletList().run();
        }}
      />
      <Toolbar.ToggleItem
        aria-label={intl.formatMessage(
          messages.editorToolbarNumberListAriaLabel,
        )}
        icon={ListNumber}
        value={LIST_STYLES.ORDERED_LIST}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
      />
    </Toolbar.ToggleGroup>
  );
};
